export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Heavy.5d1fc5d4.eot";